import * as React from 'react';

// Same footprint as HamburgerMenu so it can stand in for it (see the Friday
// bone easter egg in Nav.tsx). Cream fill with a currentColor outline so it
// reads as a bone in both light and dark mode.
export const BoneIcon = ({ className, onClick }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 24 24" className={className} onClick={onClick}>
      <g transform="rotate(-30 12 12)">
        <path
          d="M5.2 7.6a2.4 2.4 0 0 0-2.1 3.6l.5.8-.5.8a2.4 2.4 0 1 0 4.1 2.4l.2-.4h9.2l.2.4a2.4 2.4 0 1 0 4.1-2.4l-.5-.8.5-.8a2.4 2.4 0 1 0-4.1-2.4l-.2.4H7.4l-.2-.4a2.4 2.4 0 0 0-2-1.2z"
          fill="#ecd5a6"
          stroke="currentColor"
          strokeWidth="1.3"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
